import React, { Component } from 'react';
import '../../../src/styles/Home.css';
import { Link } from 'react-router-dom';
var Setpad = { paddingLeft: '2%' }
var Setheight = { height: '37px' }
let titlelength_1 = false, titlelength_2 = false;
export class LoginPublicationShowcase extends Component {
    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);
    }
    handleSelect(e) {
        window.scrollTo(0, 0);
    }
    componentDidMount() {

    }
    renderJournals = () => {
        return this.props.journalList != null && this.props.journalList.map((item, key) => {
            var titlePlus = typeof item.title == 'undefined' ? "" : item.title.replace(/ /g, "+");
            return (
                <div>
                    <Link onClick={this.handleSelect} to={"/PracticeArea?Id=" + item.topicId + "&name=" + item.topic.replace(/ /g, "+")}>
                        {
                            item.topic.length > 29 && key == 0 ? titlelength_1 = true :
                                (item.topic.length > 29 && key == 1 ? titlelength_2 = true :
                                    null)
                        }
                        <h1 className="HomepageHeading" style={titlelength_1 == true && key == 0 ? Setheight : titlelength_2 == true && key == 1 ? Setheight : null}>
                            <img alt="" src="/../../images/green-arrow.png" /><span style={Setpad}>{item.topic}</span></h1></Link>
                    <Link onClick={this.handleSelect} to={"/Journals/" + titlePlus + "/" + item.id}>
                        <img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="LeadingLawImg" />
                    </Link>
                    <div className="SetDesheight">
                        <br></br>
                        <Link onClick={this.handleSelect} to={"/Journals/" + titlePlus + "/" + item.id}>
                            <h2 className="BookHeading ">{item.title}</h2>
                        </Link>
                        <p className="BookBody ">{item.description != null ? item.description.substring(0, 100) : ""}</p>
                    </div>
                </div>
            )
        });
    }

    renderEncyclopedias = () => {
        return this.props.encyclopediaList != null && this.props.encyclopediaList.map((item, key) => {
            var titlePlus = typeof item.title == 'undefined' ? "" : item.title.replace(/ /g, "+");
            return (
                <div>
                    <Link onClick={this.handleSelect} to={"/PracticeArea?Id=" + item.topicId + "&name=" + item.topic.replace(/ /g, "+")}>
                        {
                            item.topic.length > 29 && key == 0 ? titlelength_1 = true :
                                (item.topic.length > 29 && key == 1 ? titlelength_2 = true :
                                    null)
                        }
                        <h1 className="Heading " style={titlelength_1 == true && key == 0 ? Setheight : titlelength_2 == true && key == 1 ? Setheight : null}>
                            <img alt="" src="/../../images/green-arrow.png" /><span style={Setpad}>{item.topic}</span></h1></Link>
                    <Link onClick={this.handleSelect} to={"/Encyclopedias/" + titlePlus + "/" + item.id}>
                        <img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="LeadingLawImg" />
                    </Link>
                    <div className="SetDesheight">
                        <br></br>
                        <Link onClick={this.handleSelect} to={"/Encyclopedias/" + titlePlus + "/" + item.id}>
                            <h2 className="BookHeading ">{item.title}</h2>
                        </Link>
                        <p className="BookBody ">{item.description != null ? item.description.substring(0, 100) : ""}</p>
                    </div>
                </div>
            )
        });
    }

    renderManuals = () => {
        return this.props.manualList != null && this.props.manualList.map((item, key) => {
            var titlePlus = typeof item.title == 'undefined' ? "" : item.title.replace(/ /g, "+");
            return (
                <div>
                    <Link onClick={this.handleSelect} to={"/PracticeArea?Id=" + item.topicId + "&name=" + item.topic.replace(/ /g, "+")}>
                        {
                            item.topic.length > 29 && key == 0 ? titlelength_1 = true :
                                (item.topic.length > 29 && key == 1 ? titlelength_2 = true :
                                    null)
                        }
                        <h1 className="Heading " style={titlelength_1 == true && key == 0 ? Setheight : titlelength_2 == true && key == 1 ? Setheight : null}>
                            <img alt="" src="/../../images/green-arrow.png" /><span style={Setpad}>{item.topic}</span></h1></Link>
                    <Link onClick={this.handleSelect} to={"/Manuals/" + titlePlus + "/" + item.id}>
                        <img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="LeadingLawImg" />
                    </Link>
                    <div className="SetDesheight">
                        <br></br>
                        <Link onClick={this.handleSelect} to={"/Manuals/" + titlePlus + "/" + item.id}>
                            <h2 className="BookHeading ">{item.title}</h2>
                        </Link>
                        <p className="BookBody ">{item.description != null ? item.description.substring(0, 100) : ""}</p>
                    </div>
                </div>
            )
        });
    }

    render() {
        return (           
                <div id="pub-showcase">
                    <h3 class="LawHeader">Publication showcase</h3>
                    <div className="row">
                        <div className="col-lg-4" style={{ marginLeft: '3%', maxWidth: '30%' }}>
                            {this.renderJournals()}
                            <div className="">
                                <Link to="/AllJournals" className="btn btn-info next" role="button">More Journals</Link><img src="/../../images/Arrow-Right.png" alt="" />
                            </div>
                            <div className="vl"></div>
                        </div>
                        <div className="col-lg-4" style={{ marginLeft: '3%', maxWidth: '30%' }}>
                            {this.renderEncyclopedias()}
                            <div className="">
                                <Link to="/AllEncyclopedias" className="btn btn-info next" style={{ padding: '11px 4px' }} role="button">More Encyclopaedias</Link><img src="/../../images/Arrow-Right.png" alt="" />
                            </div>
                            <div className="vl"></div>
                        </div>
                        <div className="col-lg-4" style={{ marginLeft: '3%', maxWidth: '30%' }}>
                            {this.renderManuals()}
                            <div className="">
                                <Link to="/AllManuals" className="btn btn-info next" role="button">More Manuals</Link><img src="/../../images/Arrow-Right.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>            
        )
    }
}
export default LoginPublicationShowcase;


// WEBPACK FOOTER //
// ./src/components/LoginHome/LoginPublicationShowcase.jsx